export {SizeAwareImage} from './src';
